import React from 'react';

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends React.Component<React.PropsWithChildren<{}>, ErrorBoundaryState> {
  constructor(props: React.PropsWithChildren<{}>) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Puedes enviar el error a un servicio externo aquí
    console.error('Error capturado por ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: 32,
          textAlign: 'center',
          color: '#fff',
          background: 'linear-gradient(135deg, #f43f5e 0%, #f59e42 100%)',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <div style={{
            background: 'rgba(255,255,255,0.95)',
            color: '#b91c1c',
            borderRadius: 16,
            boxShadow: '0 4px 24px 0 #0002',
            padding: 32,
            maxWidth: 420,
            width: '100%',
            margin: '0 auto',
          }}>
            <svg width="48" height="48" fill="none" viewBox="0 0 24 24" style={{ marginBottom: 16 }}>
              <circle cx="12" cy="12" r="12" fill="#f43f5e"/>
              <path d="M12 7v5" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
              <circle cx="12" cy="16" r="1.2" fill="#fff"/>
            </svg>
            <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 8 }}>¡Ha ocurrido un error inesperado!</h1>
            <p style={{ fontSize: 16, marginBottom: 16 }}>
              Para solucionarlo, por favor:
            </p>
            <ul style={{
              textAlign: 'left',
              color: '#b91c1c',
              fontSize: 15,
              margin: '0 auto 16px',
              padding: 0,
              listStyle: 'disc inside',
              maxWidth: 350,
            }}>
              <li>Borra la caché de tu navegador.</li>
              <li>Cierra la página y vuelve a entrar.</li>
              <li>O prueba abrir la web en modo incógnito.</li>
            </ul>
            <p style={{ fontSize: 14, color: '#7f1d1d', marginBottom: 8 }}>
              Si el problema persiste, contacta al soporte técnico.
            </p>
            <details style={{ whiteSpace: 'pre-wrap', marginTop: 16, color: '#b91c1c', background: '#fee2e2', borderRadius: 8, padding: 12 }}>
              {this.state.error?.toString()}
            </details>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
